import {
  SET_RESPONSE_LEAD_AUTO_SUCCESS,
  SET_RESPONSE_LEAD_AUTO_FAILURE,
  SET_RESPONSE_LEAD_AUTO_NULL
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case SET_RESPONSE_LEAD_AUTO_SUCCESS:
      return{
        ...state,
        responseLead: 'Lead asignado'
      }
    case SET_RESPONSE_LEAD_AUTO_FAILURE:
      return{
        ...state,
        responseLead: 'Lead pendiente de asignar'
      }
    case SET_RESPONSE_LEAD_AUTO_NULL:
      return{
        ...state,
        responseLead: null
      }
    default:
      return state;
  }
}